import { useState, useEffect, createContext, useContext } from "react";
import shallowEqual from "../utils/shallowEqual";
const context = createContext(undefined);
export const UseReduxProvider = context.Provider;
export function useReduxDispatch() {
    const store = useContext(context);
    if (store == null) {
        throw new Error("No store provided");
    }
    return store.dispatch;
}
export default function useRedux(mapStateToProps) {
    const store = useContext(context);
    if (store == null) {
        throw new Error("No store provided");
    }
    const [props, setProps] = useState(() => mapStateToProps(store.getState()));
    useEffect(() => {
        let current = true;
        const unsubscribe = store.subscribe(() => {
            if (!current) {
                return;
            }
            const newState = mapStateToProps(store.getState());
            if (!shallowEqual(props, newState)) {
                setProps(newState);
            }
        });
        return () => {
            current = false;
            unsubscribe();
        };
    }, [store]);
    return [props, store.dispatch];
}



// WEBPACK FOOTER //
// ./src/assets/scripts/hooks/useRedux.ts